import { Component, OnInit } from '@angular/core';
import { CtbCtaService, PageBusquedaObject, CtbCtaDto } from '../../ctb-cta/ctb-cta.service';
import Swal from 'sweetalert2';
import { LoginService } from '../../../login/login.service';
import { ValuacionService } from '../valuacion.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-valuacion-moneda-extranjera',
  templateUrl: './valuacion-moneda-extranjera.component.html',
  styleUrls: ['./valuacion-moneda-extranjera.component.css']
})
export class ValuacionMonedaExtranjeraComponent implements OnInit {
  dto: any = {valuacion_automatica: true, ganancia_o_perdida: 0, ctbTcId: 0};
  monedas: any[] = [];
  cuentas: CtbCtaDto[];
  tipo_cambio: any[] = [];
  cargado: boolean;
  id_param: number;

  busquedaCuenta: PageBusquedaObject = new PageBusquedaObject();

  constructor(private activatedRoute: ActivatedRoute, public loginService: LoginService,
    public ctaService: CtbCtaService, public service: ValuacionService, private router: Router) { }

  ngOnInit(): void {
    this.busquedaCuenta.criteriaSearch = {};
    this.busquedaCuenta.itemsPerPage = 5;
    this.busquedaCuenta.pageNumber = 0;
    this.cargarMonedas();
  }

  cargarMonedas() {
    this.service.monedas(this.loginService.empresa as number).subscribe(
      response => {
        for (let x = 0 ; x < response.contenido.length ; x++) {
          if (response.contenido[x].moneda === 'MXN') {
            continue;
          }
          this.monedas.push(response.contenido[x]);
        }
        // this.monedas = response.contenido;
        console.log(response);
        this.dto.gral_mon_id = this.monedas[0].id;
        this.cargarFormulario();
      }
    );
  }

  cargarFormulario() {
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.mostrarMensajeCarga();
        this.service.get(this.id_param).subscribe(response => {
          this.dto = response.contenido;
              this.cargarTc();
          this.cerrarMensajeCarga();
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      } else {
            this.cargarTc();
      }
    });

  }
  obtenerMoneda(gral_mon_id: number): String {
    for (let x = 0; x < this.monedas.length; x++) {
      if (gral_mon_id == this.monedas[x].id) {
        return this.monedas[x].moneda;
      }
    }
    return null;
  }
  cargarTc() {
    this.service.getTc(this.obtenerMoneda(this.dto.gral_mon_id), this.loginService.empresa as number).subscribe(
      response => {
        this.tipo_cambio = response.contenido;
        if (this.dto.ctbTcId == 0) {
        this.dto.ctbTcId = this.tipo_cambio[0].id;
      }
      }
    );
  }
  detectarNumero(texto: String): boolean {
    const numeros = '0123456789';
    for (let i = 0; i < texto.length; i++) {
      if (numeros.indexOf(texto.charAt(i), 0) !== -1) {
        return true;
      }
    }
    return false;
  }

  asignarCuenta(campo: String, buscar: String) {
    this.busquedaCuenta.criteriaSearch = {};
    this.busquedaCuenta.criteriaSearch['clasificacion'] = 4;
    switch (this.detectarNumero(buscar.replace('-', '').replace(' - ', ''))) {
      case true:
        this.busquedaCuenta.criteriaSearch['cuenta'] = buscar.split(' - ')[0];
        this.busquedaCuenta.criteriaSearch['nombre'] = '';
        break;
      case false:
        this.busquedaCuenta.criteriaSearch['cuenta'] = '';
        this.busquedaCuenta.criteriaSearch['nombre'] = buscar.split(' - ')[1];
        break;
    }
    switch (campo) {
      case 'cuenta_origen':
        this.busquedaCuenta.criteriaSearch['clave_sat_padre'] = '101:101.01:102:105:106:201:205:251:202';
        break;
      case 'cta_compl':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 5;
        break;
      case 'cuenta_util':
        this.busquedaCuenta.criteriaSearch['tipo'] = 7;
        break;
      case 'cta_perd':
        this.busquedaCuenta.criteriaSearch['tipo'] = 7;
        break;
    }
    this.busquedaCuenta.criteriaSearch['suc'] = this.loginService.sucursal;
    this.busquedaCuenta.criteriaSearch['emp'] = this.loginService.empresa;
    this.ctaService.ctaCatalogo(this.busquedaCuenta).subscribe(response => {
      this.cuentas = response.contenido.content;
      if (this.cuentas != null && this.cuentas.length === 1) {
        let nombre_cuenta = '';
        switch (this.detectarNumero(buscar.replace('-', ''))) {
          case true:
            if (this.busquedaCuenta.criteriaSearch['cuenta'] === this.cuentas[0].cuenta) {
              nombre_cuenta = this.cuentas[0].cuenta + ' - ' + this.cuentas[0].nombre;
            }
            break;
          case false:
            if (this.busquedaCuenta.criteriaSearch['nombre'] === this.cuentas[0].nombre) {
              nombre_cuenta = this.cuentas[0].cuenta + ' - ' + this.cuentas[0].nombre;
            }
            break;
        }
        switch (campo) {
          case 'cuenta_origen':
            this.dto.cta_origen_id = this.cuentas[0].id;
            this.dto.cta_origen = nombre_cuenta;
            break;
          case 'cta_compl':
            this.dto.cta_compl = nombre_cuenta;
            this.dto.cta_compl_id = this.cuentas[0].id;
            break;
          case 'cuenta_util':
            this.dto.cuenta_util = nombre_cuenta;
            this.dto.cta_util_id = this.cuentas[0].id;
            break;
          case 'cta_perd':
            this.dto.cta_perd = nombre_cuenta;
            this.dto.cta_perd_id = this.cuentas[0].id;
            break;
        }
      }
    }, err => {
      if (err.error.mensaje == null) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
    this.cuentas = [];
  }

  crear() {
    this.dto.gral_usr_crea_id = this.loginService.usuario.id as number;
    this.dto.gral_emp_id = this.loginService.empresa as number;
    this.service.post(this.dto).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/valuacion-moneda-extranjera']);
    }, err => {
      console.log(err);
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  actualizar() {
    this.dto.gral_usr_actualiza_id = this.loginService.usuario.id as number;
    this.service.put(this.dto).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/valuacion-moneda-extranjera']);
    }, err => {
      if (err.error.mensaje == null) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
